import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/professional-certificate-category-pages/appEnv';

export default appStarterFactory(appEnv);
